import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Checkbox } from '@mui/material';

const CheckboxOption = React.memo(({ name, checked, onChange, label }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={onChange}
          name={name}
          sx={{
            color: '#cbd5e1',
            '&.Mui-checked': {
              color: '#0f172a',
            },
          }}
        />
      }
      label={label}
      sx={{
        '& .MuiFormControlLabel-label': {
          fontSize: '0.875rem',
          color: '#000',
        },
      }}
    />
  );
});

CheckboxOption.displayName = 'CheckboxOption';

CheckboxOption.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

export default CheckboxOption;
